import airplane from "../../Assets/images/projects/airplane.png";
import coffee from "../../Assets/images/projects/coffee.png";
import eclipse from "../../Assets/images/projects/eclipse.png";
import trello from "../../Assets/images/projects/trello.png";
import behindchange from "../../Assets/images/projects/behindchange.png";
import violin from "../../Assets/images/projects/violin.png";
import prevport from "../../Assets/images/projects/prevport.png";
import tetris from "../../Assets/images/projects/tetris.png";

export const projectsdata = [
  {
    link: "/airplane",
    title: "Airplane Stats",
    shortdesc:
      "An interactive map which doubles as a cost of jet fuel estimator.",
    pic: airplane,
    tags: ["React", "JavaScript", "Web App"],
  },
  {
    link: "/coffee",
    title: "CoffeeHaus Daily Manager",
    shortdesc: "A daily manager project, with all info saved to the cloud.",
    pic: coffee,
    tags: ["React", "JavaScript", "Firebase", "Web App"],
  },
  {
    link: "/eclipse",
    title: "Eclipse",
    shortdesc: "A multiplayer web game, developed using JavaScript and CSS.",
    pic: eclipse,
    tags: ["JavaScript", "Object Oriented", "Game"],
  },
  {
    link: "/trello",
    title: "CoffeeHaus Kanban Project Manager",
    shortdesc: "A Trello clone project, with all info saved to the cloud.",
    pic: trello,
    tags: ["React", "JavaScript", "Firebase", "Web App"],
  },
  {
    link: "/behindchange",
    title: "Behind Change",
    shortdesc:
      "A website for helping non-profits and positive impact companies.",
    pic: behindchange,
    tags: ["React", "JavaScript", "Website"],
  },
  {
    link: "/violin",
    title: "Donna Wolf Violinist",
    shortdesc:
      "A website for Donna Wolf Violinist, a Memphis area violinist for your next wedding or event!",
    pic: violin,
    tags: ["Website"],
  },
  {
    link: "/prevport",
    title: "Previous Portfolio",
    shortdesc:
      "My previously designed portfolio. This website was developed using vanilla HTML5, CSS, and JavaScript.",
    pic: prevport,
    tags: ["JavaScript", "Website"],
  },
  {
    link: "/tetris",
    title: "Tetris Clone",
    shortdesc: "My take on Tetris. Developed in C++.",
    pic: tetris,
    tags: ["C++", "Object Oriented", "Game"],
  },
];
